export { default as Footer } from './Footer';
export { default as Hero } from 'templates/layout/Hero';
export { default as Navbar } from './navbar';
export { default as SEO } from './SEO';
export { default as Error } from './Error';
